import { PoundBoxIcon } from './PoundBoxIcon';

/**
 * author: Austin Andrews
 * id 597DF175-F0F5-4892-9F13-EA712DBC947E
 * name pound-box
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pound-box.svg
 * tags
 */
export const HashtagBoxIcon = PoundBoxIcon;
export default HashtagBoxIcon